/**
 * CollectionStep.tsx — step 3 of the VER-128 Create Programme preview: shows the matched
 * story collection for review before it is locked in. Body content is the shared
 * CollectionOverviewPanel; this file adds only the step-specific chrome (eyebrow, intro
 * copy, title + pill) that the standalone collection-overview page does not use.
 */
import React from "react";
import { Chip, Stack, Typography } from "@mui/material";
import { CollectionOverview } from "./createProgramme.types";
import { CollectionOverviewPanel } from "./CollectionOverviewPanel";

export const CollectionStep: React.FC<{ collection: CollectionOverview }> = ({ collection }) => {
    return (
        <Stack spacing={3}>
            <Stack spacing={1}>
                <Typography variant="overline" color="primary.main">
                    Step 3 of 4
                </Typography>
                <Typography variant="body1" color="secondary.dark" sx={{ lineHeight: 1.6, maxWidth: "78ch" }}>
                    Here are some Story collections for your age range - review this collection and select or view
                    another collection
                </Typography>
                <Stack direction="row" spacing={1.5} alignItems="center" flexWrap="wrap" useFlexGap>
                    <Typography variant="h3" component="h2" color="secondary.main">
                        {collection.name}
                    </Typography>
                    <Chip label="Collection title" size="small" sx={{ textTransform: "none" }} />
                </Stack>
            </Stack>

            <CollectionOverviewPanel collection={collection} />
        </Stack>
    );
};
